const gray = (canvas, w = 320) => {
  const h = Math.round((canvas.height / canvas.width) * w);
  const c = document.createElement("canvas");
  c.width = w; c.height = h;
  const ctx = c.getContext("2d", { willReadFrequently: true });
  ctx.drawImage(canvas, 0, 0, w, h);
  const px = ctx.getImageData(0, 0, w, h).data;
  const g = new Float32Array(w * h);
  for (let i = 0; i < w * h; i++) g[i] = 0.299 * px[i * 4] + 0.587 * px[i * 4 + 1] + 0.114 * px[i * 4 + 2];
  return { g, w, h };
};

// Brightness and sharpness (variance of the Laplacian) of a captured frame.
export const quality = (canvas) => {
  const { g, w, h } = gray(canvas);
  let sum = 0, clip = 0;
  for (let i = 0; i < g.length; i++) { sum += g[i]; if (g[i] > 250) clip++; }
  const lum = sum / g.length;
  let n = 0, m = 0, m2 = 0;
  for (let y = 1; y < h - 1; y++) for (let x = 1; x < w - 1; x++) {
    const i = y * w + x;
    const l = g[i - w] + g[i + w] + g[i - 1] + g[i + 1] - 4 * g[i];
    n++; const d = l - m; m += d / n; m2 += d * (l - m);
  }
  const sharp = m2 / n;
  return { lum, sharp, dark: lum < 60, bright: clip / g.length > 0.3, blurry: sharp < 40 };
};

// On-device face count where the browser supports it (mainly Chrome on Android); null when unsupported.
export const faceCount = async (canvas) => {
  if (!("FaceDetector" in window)) return null;
  try { return (await new window.FaceDetector({ fastMode: true, maxDetectedFaces: 3 }).detect(canvas)).length; } catch { return null; }
};
